/**
 * TimedStepType - Type de step pour les étapes avec timer (ESCAPE)
 * Déclare les extraFields pour ce StepType
 * Utilisé pour STEP_TIMED_SIMPLE et STEP_TIMED_PASSWORD
 */

import {StepType} from '../../types/StepType';
import {ExtraFieldType} from '../../types/ExtraFieldType';
import GameRegistry from '../../GameRegistry';

export class TimedStepType implements StepType {
  typeName = 'STEP_TIMED_SIMPLE'; // Utilisé pour STEP_TIMED_SIMPLE et STEP_TIMED_PASSWORD

  /**
   * Retourne les types d'extraFields déclarés pour ce StepType
   * Agnostique : le GameStateHelper utilise cette méthode pour savoir quels extraFields initialiser
   * Les types sont enregistrés dans le GameRegistry par EscapeSystem
   */
  getStepExtraFieldTypes(): ExtraFieldType[] {
    // Récupérer le type TIMED depuis le GameRegistry (agnostique)
    const timedType = GameRegistry.getExtraFieldType('TIMED');
    return timedType ? [timedType] : [];
  }
}

/**
 * TimedPasswordStepType - Type de step pour les étapes mot de passe avec timer (ESCAPE)
 * Utilise les mêmes extraFields que TimedStepType
 */
export class TimedPasswordStepType implements StepType {
  typeName = 'STEP_TIMED_PASSWORD';

  /**
   * Retourne les types d'extraFields déclarés pour ce StepType
   * Agnostique : le GameStateHelper utilise cette méthode pour savoir quels extraFields initialiser
   */
  getStepExtraFieldTypes(): ExtraFieldType[] {
    // Même logique que TimedStepType
    const timedType = GameRegistry.getExtraFieldType('TIMED');
    return timedType ? [timedType] : [];
  }
}
